import React from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { SectionNames } from './PortalState/SectionDataMetaData';
import { MetaData, APP_TYPE_LIST } from "./PortalState/SectionDataMetaData";

import UploadLogo from "../../../components/UploadLogo";
import DividerComponent from "../Components/DividerComponent";
import ToggleSwitchLabel from "./Components/ToggleSwitchLabel";
import SwitchInput from "../../../components/SwitchInput";
import SettingSelectField from "../../../components/SettingSelectField";
import OrderGroupingDurationControl from "./Components/OrderDurationControl";

const ImagesTab = ({ sectionName, data, uploadLogoFile, onRemoveFile, handleChange, imageLoading, imageType, styles, error }) => {
    const handleSelectChange = (val) => {
        handleChange(SectionNames.ImagesTab, MetaData[SectionNames.ImagesTab].select.appType.name, val);
    }

    return (
        <>
            <Grid
                mt={2}
                container
                direction="row"
                item
                xs={12}
                md={12}
                mb={2}
            >
                {Object.entries(MetaData[SectionNames.ImagesTab].images).map(([name, metaData]) => {
                    return (<Box mr={2} mb={1} key={name}>
                        <UploadLogo
                            type={metaData.name}
                            sectionName={sectionName}
                            uploadFile={(data, file) => uploadLogoFile(data, file, name, SectionNames.ImagesTab)}
                            imageLoading={imageLoading}
                            logoImg={data[name]}
                            imageType={imageType}
                            placeholder={metaData.label}
                            showViewUploadIcon={true}
                            onRemove={() => onRemoveFile(SectionNames.ImagesTab, metaData.name)}
                            info={metaData.info}
                        />
                    </Box>);
                })}
            </Grid >

            <DividerComponent />

            <Grid container alignItems="center" mt={1} mb={3}>
                {Object.entries(MetaData[SectionNames.ImagesTab].switches).map(([name, metaData]) =>
                    < Box mt={2} display="flex" alignItems="center" mr={4} key={name}>
                        <ToggleSwitchLabel
                            label={metaData.label}
                            info={metaData.info}
                        />
                        <SwitchInput
                            checked={data[name]}
                            onChange={val => handleChange(SectionNames.ImagesTab, name, val)}
                        />
                    </Box>)
                }
            </Grid >

            {data.batchOrderEnabled &&
                <>
                    <DividerComponent />
                    <Box mt={2} display="flex" alignItems="baseline" my={3}>
                        <ToggleSwitchLabel
                            label={"Order Grouping Duration"}
                            info={"Set the duration for order grouping (min: 1, max: 15)"}
                        />
                        <OrderGroupingDurationControl
                            value={data.batchDuration}
                            setValue={val => handleChange(SectionNames.ImagesTab, "batchDuration", val)}
                            min={1}
                            max={15}
                        />
                    </Box>
                </>
            }

            <DividerComponent />

            <Grid container item xs={12}>
                <Grid item xs={12} md={3} mt={2} mb={2}>
                    <Box mb={1}>
                        <Typography className={styles?.textInputLabel}>
                            App Type
                        </Typography>
                    </Box>
                    <Box>
                        <SettingSelectField
                            page={"customRestaurantInfo"}
                            value={data.appType}
                            setValue={handleSelectChange}
                            border={"1px solid #AAA"}
                            placeholder={""}
                            required={true}
                            variant={"filled"}
                            menuList={APP_TYPE_LIST}
                            error={error?.appType}
                        />
                    </Box>
                </Grid>
            </Grid>
        </>
    )
}

export default ImagesTab;
